import React from "react";
import { useOnboardingStore } from "../../../store/onboardingStore";
import { validateField } from "../../../utils/onboardingValidation";
import { FormInput } from "../index";
import styles from "./Step2ContactInfo.module.css";

export const Step2ContactInfo: React.FC = () => {
    const { formData, errors, updateFormField, clearError } = useOnboardingStore();

    const handleFieldChange = (field: keyof typeof formData, value: any) => {
        updateFormField(field, value);
        // Clear error for this field when user starts typing/changing it
        if (errors.has(field as string)) {
            clearError(field as string);
        }
    };

    const handleFieldBlur = (field: string, value: any) => {
        const validation = validateField(field, value);
        // Errors are managed by the store
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.iconBox}>
                    <svg className={styles.icon} fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" />
                    </svg>
                </div>
                <div>
                    <h3 className={styles.title}>Contact Information</h3>
                    <p className={styles.subtitle}>How can we reach you?</p>
                </div>
            </div>

            <div className={styles.formGroup}>
                <FormInput
                    label="Full Name"
                    name="contactName"
                    value={formData.contactName}
                    onChange={(value) => handleFieldChange("contactName", value)}
                    onBlur={(value) => handleFieldBlur("contactName", value)}
                    placeholder="Enter your full name"
                    required
                    error={errors.get("contactName")}
                    helperText="Your full name"
                />

                <FormInput
                    label="Email Address"
                    name="contactEmail"
                    value={formData.contactEmail}
                    onChange={(value) => handleFieldChange("contactEmail", value)}
                    onBlur={(value) => handleFieldBlur("contactEmail", value)}
                    type="email"
                    placeholder="example@company.com"
                    required
                    error={errors.get("contactEmail")}
                    helperText="We'll send important updates to this email"
                    autoComplete="email"
                />

                <FormInput
                    label="Contact Number"
                    name="contactPhone"
                    value={formData.contactPhone}
                    onChange={(value) => handleFieldChange("contactPhone", value)}
                    onBlur={(value) => handleFieldBlur("contactPhone", value)}
                    type="tel"
                    placeholder="(555) 555-5555"
                    required
                    error={errors.get("contactPhone")}
                    helperText="10-digit phone number with area code"
                    formatType="phone"
                    maxLength={14}
                    autoComplete="tel"
                />
            </div>

            {/* Information Box */}
            <div className={styles.infoBox}>
                <div className={styles.infoContent}>
                    <div className={styles.infoIcon}>
                        <svg fill="currentColor" viewBox="0 0 20 20">
                            <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                        </svg>
                    </div>
                    <div>
                        <p className={styles.infoTitle}>Contact Information Privacy</p>
                        <p className={styles.infoText}>
                            Your contact information is secure and encrypted. We'll use this to reach you regarding your
                            application and account.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
